<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs2 md2 >
        <v-btn color="primary" dark text  @click="showEditDialog(true)">新增</v-btn>
      </v-flex>
    </v-layout>
    <v-layout xs12>
      <v-flex md2 xs8>
        <v-autocomplete
          v-model="selectAgentId"
          background-color="#49bcfd"
          outline
          :items="getAgentListInfo"
          label="經銷"
          item-text="text"
          item-value="key"
          @change="loadData"
        ></v-autocomplete>
      </v-flex>
      <v-flex ml-2 md4 xs8>
        <v-text-field v-model="search.keyword" :label="`搜尋姓名或身份證`" :placeholder="search.placeholder"
                      @keyup.enter="searchEvent"></v-text-field>
      </v-flex>
      <v-flex md4 xs4>
        <v-btn color="success" @click="searchEvent">搜尋</v-btn>
        <v-btn color="warning" @click="reset">重置</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap mt-2>
      <v-container
        fluid>
        <table-view :columnKeys="columnKeys"
                    :items="items"
                    :loading="loading"
                    :total-items="totalItems"
                    @cellEvent="cellEvent"
                    @changePage="changePage"
                    @handleLoadData="reset">
        </table-view>
      </v-container>
    </v-layout>

    <AssignorDialog :visible="assignorDialog.visible"
                      :title="assignorDialog.title"
                      :item="assignorDialog.item"
                      :isNew="assignorDialog.isNew"
                      :loading="assignorDialog.loading"
                      @confirmEvent="fileDialogConfirm"
                      @cancelEvent="assignorDialog.visible = false"></AssignorDialog>

  </v-container>
</template>

<script>
import AlertView from '@/components/AlertView';
import TableView from '@/components/TableView';
import { mapActions, mapGetters } from 'vuex';
import common from '@/mixins/common';
import AssignorDialog from '@/components/AssignorDialog';
import AssignorModel from '@/models/AssignorModel';
import { deleteAssignorInfo } from '@/store/actions';
export default {
  name: 'assignorList',
  mixins: [common],
  components: {
    AssignorDialog,
    AlertView,
    TableView,
  },
  data(){
    return {
      mode: '',
      startDate: '',
      endDate: '',
      loading: false,
      pageIndex: 1,
      limit: 50,
      totalItems: 0,
      saveLoading: false,
      search: {
        keyword: "",
        searchKey:'agentId',
      },
      selectAgentId: '',
      orignItems: [],
      items: [],
      messageDialog: {
        title: "",
        text: "",
        visible: false,
        showCancelButton: false,
        confirm: () => {},
        cancel: () => {},
      },
      assignorDialog:{
        title: "",
        visible: false,
        loading: false,
        isNew:false,
        item: new AssignorModel(),
        confirm: () => {},
        cancel: () => {},
      },
    }
  },
  created() {
    if (this.isAdmin){
      this.selectAgentId = '';
    } else {
      this.selectAgentId = this.getUserInfo.agentId;
    }

    this.loadData();
    this.fetchAgentList();
  },
  computed:{
    ...mapGetters(["getUserInfo", "getAgentList"]),
    getSearchKeys(){
      return [
        { key:'agentId', value: '經銷' },
        { key:'name', value: '姓名' },
        { key:'memberId', value: '身份證' },
      ]
    },
    columnKeys() {
      const list = [
        { value: "edit", text: "編輯", sortable: false, required: false, color: 'primary', isEvent: true },
        { value: "agentId", text: "經銷", sortable: true, required: false , options: this.getAgents() , isSelectText: true},
        { value: "name", text: "姓名", sortable: true, required: false },
        { value: "memberId", text: "身份證", sortable: true, required: false },
        { value: "cellphone", text: "電話", sortable: true, required: false },
        {
          value: "companyPhone",
          text: "公司電話",
          sortable: true,
          required: false,
        },
        {
          value: "birthday",
          text: "生日",
          sortable: true,
          required: false,
        },
        { value: "createdDate", text: "建立時間", sortable: true, required: false },
        { value: "delete", text: "刪除", sortable: false, required: false, color: 'red', isEvent: true },
      ];
      return list
    },
    getAgentListInfo(){
     return this.getAgents();
    }
  },
  methods: {
    ...mapActions(['saveAssignorInfo', 'getAssignorList', 'fetchAgentList', 'deleteAssignorInfo']),
    getAgents(){
      const list = [];
      for (let agent of this.getAgentList){
        if (agent.authority !== 'insureAgent'){
          list.push({ key: agent.agentId, text: agent.displayName });
        }
      }
      return list;
    },
    async loadData(){
      try {
        this.loading = true;

        const res = await this.getAssignorList({
          agentId: this.selectAgentId,
        });

        this.loading = false;
        const result = res.data;
        this.orignItems = result.data;
        this.items = result.data;
        this.totalItems = this.items.length;
        this.limit = this.items.length;
      } catch (e) {
        console.log(`load error `, e);
      } finally {
        this.loading = false;
      }
    },
    showEditDialog(isNew, item){
      this.assignorDialog.visible = true;
      this.assignorDialog.isNew = isNew;
      if (!isNew){
        this.assignorDialog.item = item;
      }
    },
    cellEvent(props) { // cell 按鈕事件 (用Key判斷是點選哪一個
      console.log(`edit = ${JSON.stringify(props)}`)
      if (props.key === 'edit'){
        this.showEditDialog(false, props.item);
      }
      if (props.key === 'delete'){
        this.deleteEvent(props.item.assignorId);
      }
    },
    changePage(page) { // 改變頁數 or 每頁筆數
      this.pageIndex = page.page;
      this.limit = page.rowsPerPage;
      this.loadData();
    },
    reset(){
      this.search.keyword = '';
      if (this.isAdmin){
        this.selectAgentId = '';
      } else {
        this.selectAgentId = this.getUserInfo.agentId;
      }
      this.loadData();
    },
    searchEvent(){
      if (this.orignItems.length){
        this.items = this.orignItems.filter(i=>{
          return i.name.includes(this.search.keyword) || i.memberId.includes(this.search.keyword)
        })
      }
    },
    async fileDialogConfirm(info){
      console.log(`save ${JSON.stringify(info)}`);
      try {
        this.assignorDialog.loading = true;
        let res = await this.saveAssignorInfo(info.item);
        const result = res.data;
        console.log(`result ${JSON.stringify(result)}`);

        if (result.statusCode === 0 ){
          this.resetInfo();
          this.showMessageDialog(result.message);
          this.assignorDialog.visible = false;
        } else {
          this.showMessageDialog( result.message);
        }
      } catch (e) {
        console.log(e);
        this.showMessageDialog('發生異常，請輸入格式是否正確');
      } finally {
        this.assignorDialog.loading = false;
      }
    },
    resetInfo(){
      this.assignorDialog.visible = false;
      this.assignorDialog.item = new AssignorModel();
      this.loadData();
    },
    async deleteEvent(assignorId){
      await this.deleteInfo(assignorId);
    },
    async deleteInfo(assignorId){
      console.log(`delete = ${assignorId}`);
      const res = await this.deleteAssignorInfo({
        assignorId: assignorId,
      });
      const result = res.data;
      console.log(`result ${JSON.stringify(result)}`);
      if (result.statusCode === 0 ){
        this.resetInfo();
        this.showMessageDialog(result.message);
      } else {
        this.showMessageDialog(result.message);
      }
    },
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/web/assignorList.vue